<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-11-25 16:56:15
-->
<template>
  <div
    class="component__cat-editor--sentence-source-symbol flex-center"
    :class="classNames"
  >
    {{ textContent }}
  </div>
</template>

<script>
import { TARGET_SOURCE } from "./data";
export default {
  props: {
    source: {
      type: Number,
    },
    score: {
      type: Number,
    },
    isChanged: {
      type: Boolean,
    },
  },
  computed: {
    classNames() {
      if (this.source == null || this.source == TARGET_SOURCE.manual) {
        return "source__empty";
      }

      const res = [];
      switch (this.source) {
        case TARGET_SOURCE.autofillByTM:
          if (this.score > 100) {
            res.push("source__tm--cm");
          } else if (this.score == 100) {
            res.push("source__tm--100");
          } else {
            res.push("source__tm--approximate");
          }
          break;
        case TARGET_SOURCE.autofillByMT:
          res.push("source__mt");
          break;
      }
      if (this.isChanged) {
        res.push("user-edited");
      }
      return res;
    },
    textContent() {
      switch (this.source) {
        case TARGET_SOURCE.autofillByTM:
          if (this.score > 100) {
            return "CM";
          } else {
            return `${this.score}%`;
          }
        case TARGET_SOURCE.autofillByMT:
          return "MT";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss">
.component__cat-editor--sentence-source-symbol {
  font-size: 12px;
  color: white;
  box-sizing: border-box;
  border: 2px solid transparent;

  &.source__empty {
    //border-color: #bed2f0;
  }

  &.source__tm--cm,
  &.source__tm--100 {
    border-color: #67c23a;
    background: #67c23a;
  }
  &.source__tm--approximate {
    border-color: #e6a23c;
    background: #e6a23c;
  }
  &.source__mt {
    border-color: #1b95f8;
    background: #1b95f8;
  }

  &.user-edited {
    background: white;
    color: #606266;
  }
}
</style>